import React from "react";

/**
 * @name CCTM_demo
 * @function
 * @extends React.Component
 * @exported true
 * @description This component dynamically renders a given component and provides demo navigation functionality.
 * @param {Object} props - Component properties.
 * @param {React.Component} props.component - The component to be rendered.
 * @param {Function} [props.postRender] - Optional function to modify the component before rendering.
 * @param {Object} props.demos - Object mapping abbreviations to demo URLs.
 * @param {string} props.abbr - Abbreviation used to fetch the demo URL.
 * @param {string} props.target - Specifies where to open the demo ('self' or 'window').
 * @example
 * export default function CCTM_demo(props) {
 *  return (
 *    <CCTM_demo component={MyComponent} demos={{ EX: 'https://example.com' }} abbr="EX" target="window" />
 *  );
 * }
 */

export default function CCTM_demo(props) {
    
    // Extract the component from props
    let Component = props.component;
    
    // If a postRender function is provided, use it to modify the component before rendering
    if (typeof props.postRender == "function") {
        Component = props.postRender(props.component, props);
    }
    
    // Click handler for navigation
    const onClick = () => {
        if (props.target === "self") {
            window.location = props.demos[props.abbr.toUpperCase()]; // Navigate within the app
        } else if (props.target === "window") {
            window.open(props.demos[props.abbr.toUpperCase()], "_blank"); // Open demo in new window
        }
    };
    
    // Render the component with navigation properties
    return <Component {...props} to={props.demos[props.abbr.toUpperCase()]} onClick={Component.onClick ?? onClick} />;
}